import { render, staticRenderFns } from "./DiligenceStudentReportFilter.vue?vue&type=template&id=b63c4f6c&scoped=true&"
import script from "./DiligenceStudentReportFilter.vue?vue&type=script&lang=js&"
export * from "./DiligenceStudentReportFilter.vue?vue&type=script&lang=js&"
import style0 from "./DiligenceStudentReportFilter.vue?vue&type=style&index=0&id=b63c4f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63c4f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
